import { getLocale } from "../runtime";

const sv_storage = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Förvaring`
};

const storage = /** @type {(inputs?: {}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "sv") return sv_storage(inputs)
	return "storage";
};

export { storage as "storage" };